import * as React from 'react';
import { SkeletonLoader } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';

const SubscriptionLineItemFailed = ()=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement(SkeletonLoader, {
        animate: false,
        className: "subscription-line-item-failed"
    }, /*#__PURE__*/ React.createElement("svg", {
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "subscription-line-item-failed__image",
        "aria-label": getLabel('common.loadingText')
    }, /*#__PURE__*/ React.createElement("rect", {
        width: "100%",
        height: "100%",
        rx: "5",
        fill: "currentColor"
    })), /*#__PURE__*/ React.createElement("p", {
        className: "subscription-line-item-failed__text"
    }, getLabel('account.subscription.product.failed')));
};
var SubscriptionLineItemFailed$1 = SubscriptionLineItemFailed;

export { SubscriptionLineItemFailed$1 as default };
//# sourceMappingURL=SubscriptionLineItemFailed.js.map
